import { useEffect, useState } from 'react';
import axiosInstance from '../api/axios';
import { COLLECTIONS as FALLBACK_COLLECTIONS } from '../data/collections';

/**
 * Fetch live hair collections from the API.
 * Falls back to the static seed file if the API is temporarily unreachable,
 * so the storefront never renders an empty section.
 *
 * The API returns documents with `styling_tip` (snake_case). We normalize
 * to camelCase `stylingTip` so the rest of the UI stays unchanged.
 */
const normalize = (c) => ({
  ...c,
  stylingTip: c.styling_tip ?? c.stylingTip ?? '',
  palette: c.palette || { bg: '#F5EDE4', accent: '#C4A084', text: '#5D4E3C' },
});

const useHairCollections = () => {
  const [collections, setCollections] = useState(FALLBACK_COLLECTIONS);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    axiosInstance
      .get('/hair-collections')
      .then((res) => {
        if (cancelled) return;
        const data = Array.isArray(res.data) ? res.data : [];
        if (data.length) setCollections(data.map(normalize));
      })
      .catch(() => {/* keep fallback */})
      .finally(() => !cancelled && setLoading(false));
    return () => { cancelled = true; };
  }, []);

  return { collections, loading };
};

export default useHairCollections;
